import '../css/PageNotFound.css';
import * as React from 'react';

interface Props {
  color?: string;
}
const PageNotFound = (props: Props): React.ReactElement<Props> => (
  <div className="page-not-found-container" data-testid="not-found">
    <div className="page-not-found-main">
      <label style={{ color: props.color || 'black' }}>
        404 - Page Not Found
      </label>
    </div>
  </div>
);

export default PageNotFound;
